import Alpine, { AlpineComponent } from "alpinejs";
import { BasketService, BasketViewModel } from "../api";
import { MiniCartStore } from "./store/miniCartStore";
type MiniCart = AlpineComponent<unknown>;

export default (): MiniCart => ({
	async init() {
		try {
			await BasketService.getBasket().then((response) => {
				if (response.response.status !== 200) {
					return;
				}
				let numberOfItems = 0;
				const basket = response.data as BasketViewModel;
				basket?.items?.forEach((item) => {
					if (item.hasMLEUnit) {
						numberOfItems += item.quantity / item.mleFactor;
					} else {
						numberOfItems += item.quantity;
					}
				});
				(Alpine.store("cart") as MiniCartStore).setItemCount(numberOfItems, false);
			});
		} catch (error) {
			console.error("Error fetching basket data:", error);
		}
	},
});
